export default {"src":"/_next/static/media/credit_card_300.2247ab4a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};